import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MatrixBackground from './components/MatrixBackground';
import Header from './components/Header';
import About from './components/About';
import Contact from './components/contact';
import Resume from './components/Resume';
import Projects from './components/Projects';
import Terminal from './components/terminal';
import { ApolloClient, InMemoryCache, createHttpLink, gql } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";




const fetchPinnedItems = async () => {
   const TOKEN = "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";
 
   const client = new ApolloClient({
    uri: 'https://api.github.com/graphql',
    
    headers: {
      Authorization: `Bearer ${TOKEN}`, // Use environment variable for the token
    },
    cache: new InMemoryCache(),
  });

  console.log('Fetching pinned items...');

  const { data } = await client.query({
    query: gql`
      query {
        viewer {
          login
          pinnedItems(first: 4) {
            totalCount
            edges {
              node {
                ... on Repository {
                  id
                  name
                  url
                  object(expression: "HEAD:README.md") {
                    ... on Blob {
                      text
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });


  return data.viewer.pinnedItems.edges.map((edge) => edge.node);
};

const App = () => {
  const [pinnedItems, setPinnedItems] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchPinnedItems();
        setPinnedItems(data);
      } catch (error) {
        console.error('Error fetching pinned items:', error);
      }
    };
    loadData();
  }, []);


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCA-FEfhp6ns7GJNYDwCNt5LTAA05GHI5A",
  authDomain: "profile-837f8.firebaseapp.com",
  databaseURL: "https://profile-837f8-default-rtdb.firebaseio.com",
  projectId: "profile-837f8",
  storageBucket: "profile-837f8.firebasestorage.app",
  messagingSenderId: "439841097448",
  appId: "1:439841097448:web:e40faac3bc95fbe5f8eb5d",
  measurementId: "G-52D8Z8R0W3"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebase);


  return (
    <Router>
      <MatrixBackground />
      <Routes>
        <Route
          path="/"
          element={
            <div
              style={{
                position: 'relative',
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: '2rem',
                padding: '5rem',
              }}
            >
              <Header />
              <About />
              <Terminal pinnedItems={pinnedItems} />
              <Contact firebase={firebase}/>
            </div>
          }
        />
        <Route path="/resume" element={<Resume />} />
        <Route path="/projects" element={<Projects />} />
      </Routes>
    </Router>
  );
};

export default App;
